export const backgroundImages = [
    "/images/game/backgrounds-game-1.jpg",
    "default-background",
    "/images/game/backgrounds-game-1.jpg",
    "default-background",
  ];